import Link from 'next/link';
import { styled } from 'styled-components';

import { mq, rowXBetweenYCenter } from '@/shared/ui/styled';

export const StyledDocumentContainer = styled.div`
    width: 100%;
    background-color: ${({ theme }) => theme.color.secondary};
    border-radius: 12px;
    padding: 24px;

    a:last-child {
        border-bottom: none;
    }

    ${mq.xs} {
        padding: 24px 12px;
    }
`;

export const StyledDocument = styled(Link)`
    width: 100%;
    padding: 24px 0;
    ${rowXBetweenYCenter}
    font-family: 'Rounded Mplus 1c';
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.sm};
    line-height: 130%;
    color: ${({ theme }) => theme.color.dark};
    border-bottom: 1px solid ${({ theme }) => theme.color.neutral400};

    &:hover {
        cursor: pointer;
    }

    svg:last-child {
        margin-left: 10px;
    }

    ${mq.xs} {
        padding: 20px 0;
    }
`;

export const StyledIconWrapper = styled.div`
    height: 30px;
    ${rowXBetweenYCenter}
`;

export const StyledBox = styled.div`
    ${rowXBetweenYCenter}

    svg {
        margin-right: 12px;
    }
`;
